// Plays muted looping videos marked data-nv-video only while they are on screen; respects reduced motion.
(function () {
  if (window.nvVideoInit) return;
  window.nvVideoInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function wire(v) {
    if (v.dataset.nvWired) return;
    v.dataset.nvWired = '1';
    v.muted = true;
    if (reduce || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 }).observe(v);
  }
  function scan() { document.querySelectorAll('video[data-nv-video]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
